import { Narrow, Pad } from 'component/basics';
import { UtilityText } from 'component/text';
import { TabBar, TabContent, TabNavigation } from 'open-modules/zdf/tabnavigation';
import { View } from 'react-native';
import { CLICK, DemoSection } from 'system/demo';
import { t } from 'util/stdtypes';

const tabs = [
    {
        id: 'tab-1',
        label: t('!Tab 1'),
        component: Tab1,
    },
    {
        id: 'tab-2',
        label: t('!Tab 2'),
        component: Tab2,
    },
];

const singleTab = [
    {
        id: 'tab-single',
        label: t('!Single Tab'),
        component: SingleTab,
    },
];

function Tab1() {
    return <UtilityText text='This is the first tab.' />;
}

function Tab2() {
    return <UtilityText text='This is the second tab.' />;
}

function SingleTab() {
    return <UtilityText text='This is the only tab.' />;
}

export function TabNavigationDemo() {
    return (
        <Narrow>
            <DemoSection text='TabBar with full width'>
                <TabNavigation initialTabId={'tab-1'} tabs={tabs}>
                    <TabBar />
                    <Pad />
                    <TabContent />
                </TabNavigation>
            </DemoSection>
            <DemoSection text='TabBar with width fit to content'>
                <TabNavigation initialTabId={'tab-1'} tabs={tabs}>
                    <View style={{ width: 'fit-content' }}>
                        <TabBar />
                    </View>
                    <Pad />
                    <TabContent />
                </TabNavigation>
            </DemoSection>
            <DemoSection text='Only 1 tab'>
                <TabNavigation tabs={singleTab}>
                    <View style={{ width: 'fit-content' }}>
                        <TabBar />
                    </View>
                    <Pad />
                    <TabContent />
                </TabNavigation>
            </DemoSection>
        </Narrow>
    );
}

export function TabNavigationStorySets() {
    return [
        {
            name: 'Tab Navigation Actions',
            instanceKey: 'a',
            personaKey: 'a',
            sessionData: {},
            globals: null,
            content: (
                <View>
                    <TabNavigation initialTabId={'tab-1'} tabs={tabs}>
                        <TabBar />
                        <Pad />
                        <TabContent />
                    </TabNavigation>
                </View>
            ),
            stories: [
                {
                    name: 'Switch tab',
                    actions: [CLICK(tabs[1].label), CLICK(tabs[0].label)],
                },
            ],
        },
    ];
}
